(function ($) {
	$(document).on('click', '.fancy-thumbnail', (ev) => {
		const $target = $(ev.currentTarget);
		const postId = $target.attr('data-post-id');

		const popup = new Popup({
			padding: true,
			loading: true,
			size: 'medium'
		});

		popup.openPopup();

		const data = {
			action: 'get_our_works_post_popup_content',
			post_id: postId
		};

		$.post(globalSettings.ajax_url, data).done( (response) => {
			const $content = $(response.data.content);

			popup.setContent($content);
		});
	});
})(jQuery);